import { generateOtp } from "./otpService";

export const generateOtpAction = (payload) => async () => {
  const response = await generateOtp(payload);
  return response;
};